import React, { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material";
import api from "../api";
import FilterPanel from "./FilterPanel";
import DemandDashboard from "./DemandDashboard";
import { filterTemplate } from "../config/demandSupplyConfig";
import { toDisplayName } from "../utils/columnUtils";

export default function DemandMappingReport() {
  const [sourceRows, setSourceRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const clearRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError("");
    api.get("/demandselect", { signal: controller.signal })
      .then(({ data }) => { const next = Array.isArray(data) ? data : []; setSourceRows(next); setRows(next); })
      .catch((requestError) => { if (requestError.code !== "ERR_CANCELED") setError(requestError.response?.data?.error || "Unable to load Demand Mapping data"); })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, []);

  const columns = useMemo(() => sourceRows[0]
    ? Object.keys(sourceRows[0]).map((field) => ({ field, headerName: toDisplayName(field) }))
    : [], [sourceRows]);

  return <Box>
    <Box sx={{ mb: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, color: "#164d73" }}>Demand Mapping</Typography>
      <Typography variant="body2" color="text.secondary">Demand distribution, fulfilment signals, and drill-through detail.</Typography>
    </Box>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    <Paper variant="outlined" sx={{ p: 1, mb: 2 }}>
      <FilterPanel initialData={sourceRows} setData={setRows} template={filterTemplate} onClearAllRef={clearRef} compact />
    </Paper>
    {loading && !sourceRows.length
      ? <Box sx={{ minHeight: 360, display: "grid", placeItems: "center" }}><CircularProgress /></Box>
      : <DemandDashboard data={rows} columns={columns} loading={loading} />}
  </Box>;
}
